export const serviceSlugs = ['development', 'automation', 'hardware', 'products', 'other'] as const;

export type ServiceSlug = (typeof serviceSlugs)[number];

const serviceLabels: Record<ServiceSlug, string> = {
  development: 'Custom Software',
  automation: 'Industrial Automation',
  hardware: 'Hardware',
  products: 'IOFireBug products',
  other: 'Something else',
};

export const serviceOptions = serviceSlugs.map((value) => ({ value, label: serviceLabels[value] }));

export function isServiceSlug(value: unknown): value is ServiceSlug {
  return serviceSlugs.some((slug) => slug === value);
}

export function serviceLabel(slug: ServiceSlug): string {
  return serviceLabels[slug];
}
